/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      // toggleNextButton();

      // $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
      //   toggleNextButton();
      // } );

      // function toggleNextButton() {
      //   if ( $( '.current-page' ).hasClass( 'radio-page' ) ) {
      //     $( '.next_button' ).addClass( 'sr-only' );
      //   } else {
      //     $( '.next_button' ).removeClass( 'sr-only' );
      //   }
      // }

      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        $( '.quoter-nav .curr-page-num' ).text( parseInt( currentPage ) );
        if ( window.innerWidth > 1023 ) {
          $( 'html, body' ).animate( {scrollTop: 0}, 'slow' );
        } else {
          $( 'html, body' ).animate( {scrollTop: 0}, 'slow' );
        }
      } );

      $( '.quoter-page--1 .quoter-next-page' ).on( 'click', function() {
        $( '.quoter-page--1' ).removeClass( 'is-active' );
        $( '.quoter-page--2' ).addClass( 'is-active' );
      } );

      $( '.quoter-page--2 .first-name-trigger' ).on( 'submit', function( e ) {
        e.preventDefault();
        $( '.quoter-page--2' ).removeClass( 'is-active' );
        $( '.quoter-page--3' ).addClass( 'is-active' );

        if ( $( '.quoter-page--2 input' ).val().length ) {
          $( '.fill-first-name' ).text( ' ' + $( '.quoter-page--2 input' ).val() );
          $( '.quoter-form .first-name-field input' ).val( $( '.quoter-page--2 input' ).val() );
        } else {
          $( '.fill-first-name__wrapper .high-contrast' ).removeClass( 'high-contrast' );
        }

        setTimeout( function() {
          $( '.quoter-page--3' ).removeClass( 'is-active' );
          $( '.quoter-page--quoter' ).addClass( 'is-quoter-active' );
          setTimeout( function() {
            $( '.quoter-page:not(.quoter-page--quoter)' ).addClass( 'is-finished' );
            $( '.quoter-page--quoter' ).addClass( 'is-active' );
          }, 1000 );
        }, 3000 );
      } );

      $( document ).on( 'change', '.llgq-current-page input[type="radio"]', function() {
        if ( $( '.llgq-current-page' ).hasClass( 'radio-page' ) ) {
          $( '.llgq-current-page .gform_next_button' ).trigger( 'click' );
        }
      } );
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'quoter', COMPONENT );
} )( app );
